<template>
  <v-container>
    <v-row dense align="center" justify="space-between">
      <v-col cols="auto">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>

      <v-col class="text-center">
        <div class="text-h4 font-weight-bold mb-2">
          🐝 Producción y Venta Apícola
        </div>
      </v-col>
      <v-col cols="12" class="pb-3">
        <div class="text-h7">
          Presiona el botón para agregar una producción de Abejas, miel, polen,
          etc
        </div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/apicultura" depressed class="primary">
          <span style="font-size: 30px">🍯</span>
          <v-icon left>mdi-plus</v-icon>
          Agrega una Nueva Producción
        </v-btn>
      </v-col>
      <v-col cols="12" class="tt">
        <div class="text-h5 font-weight-bold mb-2">
          Mis producciones y Ventas
        </div>
        <div class="text-h8">
          Presiona la producción de abejas para agregar Ventas, producción o modificarlas
        </div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
      <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas  -->
      <v-col v-if="Object.keys(apiculturas).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna producción apícola
        </div>
      </v-col>
      <!-- listado de actividades apícolas en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="apicultura in apiculturas">
            <form-card
              :key="apicultura.id"
              :top-text="`Finca : ${getNombreDeFinca(apicultura.id_finca)}`"
              :middle-text="apicultura.descripcion"
              :bottom-text="`Cantidad de Colmenas: ${apicultura.colmenas}`"
              :top-right-text="apicultura.fecha"
              :bottom-right-text="producerDescription(apicultura.productor)"
              :sincronized="apicultura.sincronizado"
              :opaque="apicultura.hasOutdatedRecords"
              @click="traerRegistroYNavegar(apicultura)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Apiculturas',
  computed: {
    ...mapState('registros', ['apiculturas']),
    ...mapGetters('registros', ['getNombreDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Apiculturas')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getApicultura', {
          id: registro.id,
        })
      }
      this.$router.push(`/ru/apicultura/${registro.id}`)
    },
  },
}
</script>
<style>
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>
